import { useEffect } from 'react';
import { ACTION_TYPES, useParametersDispatch, useParametersState } from './parameters-context';
import ParametersAppService from '../../../../application/platform/apm/parameters/parameters-app-service';
import { useActionRunner } from '../../../../hooks/use-action-runner';
import { hasErrors } from '../../../../utils/validation';
import { buildParametersRequest, ParametersField, TAB_FIELDS, validateParameters } from '../components/parameters-utils';

export const useParametersController = () => {
    const dispatch = useParametersDispatch();
    const state = useParametersState();
    const { isSaving, runSaving, run, showSuccess } = useActionRunner();

    async function loadParameters() {
        dispatch({ type: ACTION_TYPES.setLoading, payload: true });
        await run('Não foi possível carregar os parâmetros do portal', async () => {
            dispatch({ type: ACTION_TYPES.setParameters, payload: await ParametersAppService.get() });
        });
        dispatch({ type: ACTION_TYPES.setLoading, payload: false });
    }

    useEffect(() => {
        loadParameters();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function handleChange(field: ParametersField, value: string) {
        dispatch({ type: ACTION_TYPES.updateForm, payload: { [field]: value } });
    }

    function handleTabChange(tab: number) {
        dispatch({ type: ACTION_TYPES.setTab, payload: tab });
    }

    function handleSave() {
        const errors = validateParameters(state.form);
        if (hasErrors(errors)) {
            dispatch({ type: ACTION_TYPES.setShowValidationErrors, payload: true });
            // Leva o usuário para a primeira aba com erro, caso a atual esteja válida
            if (!TAB_FIELDS[state.tab].some((f) => errors[f])) {
                handleTabChange(TAB_FIELDS.findIndex((fields) => fields.some((f) => errors[f])));
            }
            return;
        }
        return runSaving('Não foi possível salvar os parâmetros do portal', async () => {
            // A resposta volta com os textos já normalizados pela API (maiúsculas), por isso recarrega o formulário
            dispatch({ type: ACTION_TYPES.setParameters, payload: await ParametersAppService.update(buildParametersRequest(state.form)) });
            showSuccess('Parâmetros do portal salvos com sucesso!');
        });
    }

    function handleDiscard() {
        dispatch({ type: ACTION_TYPES.resetForm });
    }

    return { isSaving, handleChange, handleTabChange, handleSave, handleDiscard };
};
